/* Stock- and size-aware quick view.

   assets/jaf.js defines window.renderQuickView, which builds the quick-view
   modal body. As shipped it had three faults:

     1. No size selector at all. The hidden variant input was hardwired to
        product.variants[0], so EVERY quick-view add used the first variant
        regardless of what the shopper wanted -- quick-adding FRSH Parachute
        Pants always put size S in the bag.
     2. No stock awareness. A sold-out product still rendered an enabled
        "ADD TO BOOKBAG" wired to a sold-out variant; the add then failed.
     3. The description sat above the buying controls, so on a long product
        description the size row and add button fell below the fold of a
        scrollable pane -- the opposite of a quick add.

   This renderer defaults to the first PURCHASABLE variant, offers a size
   selector when the product has more than one variant, keeps price and button
   state in step with the selection, and puts price / sizes / add button ABOVE
   the description. It reuses jaf.js's shared window.jafAddToCart so the toast,
   cart drawer and de-duplicated request behave exactly as elsewhere.

   Loaded after jaf.js, so this definition wins. */
(function () {
  'use strict';

  function money(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function closeQuickView() {
    var backdrop = document.querySelector('#JafModalBackdrop');
    if (backdrop) backdrop.hidden = true;
    var drawer = document.querySelector('#JafDrawer');
    document.body.style.overflow = drawer && drawer.classList.contains('is-open') ? 'hidden' : '';
  }

  window.renderQuickView = function renderQuickView(product) {
    var qvContent = document.querySelector('[data-quickview-content]');
    if (!qvContent) return;

    var variants = product.variants || [];
    // Default to something the shopper can actually buy. Most of this catalogue
    // is down to one or two sizes, so variants[0] is often already gone.
    var initial = variants.filter(function (v) { return v.available; })[0] || variants[0] || {};

    // A single "Default Title" variant (hats) needs no selector.
    var hasChoices = variants.length > 1;
    var img = String(product.featured_image || (product.images && product.images[0]) || '');

    qvContent.innerHTML =
      '<div class="jaf-modal__visual" style="background:#1a1a1a">' +
        (img ? '<img src="' + esc(img) + '" alt="' + esc(product.title) + '" style="max-width:72%;max-height:72%;object-fit:contain;">' : '') +
      '</div>' +
      '<div class="jaf-modal__info">' +
        '<div class="jaf-mono jaf-modal__eyebrow">' + esc((product.type || 'APPAREL').toUpperCase()) + '</div>' +
        '<h2>' + esc(product.title) + '</h2>' +
        '<div class="jaf-modal__price"><span data-qv-price>' + money(initial.price || product.price) + '</span></div>' +
        '<form action="/cart/add" method="post" data-qv-form>' +
          (hasChoices
            ? '<div class="jaf-mono jaf-qv__size-label">SIZE</div><div class="jaf-qv__sizes">' +
                variants.map(function (v) {
                  return '<button type="button" class="jaf-qv__size' +
                    (v.id === initial.id ? ' is-active' : '') +
                    (v.available ? '' : ' is-unavailable') +
                    '" data-qv-option="' + v.id + '">' + esc(v.title) + '</button>';
                }).join('') +
              '</div>'
            : '') +
          '<input type="hidden" name="id" value="' + esc(initial.id) + '" data-qv-variant>' +
          '<button type="submit" class="jaf-btn jaf-btn--primary jaf-btn--block" data-qv-add' +
            (initial.available ? '' : ' disabled') + '>' +
            (initial.available ? 'ADD TO BOOKBAG — ' + money(initial.price) : 'SOLD OUT') +
          '</button>' +
        '</form>' +
        '<div class="jaf-modal__desc jaf-qv__desc">' + (product.description || '') + '</div>' +
      '</div>';

    var qvForm = qvContent.querySelector('[data-qv-form]');
    var qvHidden = qvContent.querySelector('[data-qv-variant]');
    var qvAdd = qvContent.querySelector('[data-qv-add]');
    var qvPrice = qvContent.querySelector('[data-qv-price]');

    function select(variant) {
      if (!variant || !qvHidden) return;
      qvHidden.value = variant.id;
      if (qvPrice) qvPrice.textContent = money(variant.price);
      if (!qvAdd) return;
      qvAdd.disabled = !variant.available;
      qvAdd.textContent = variant.available
        ? 'ADD TO BOOKBAG — ' + money(variant.price)
        : 'SOLD OUT';
    }

    qvContent.querySelectorAll('[data-qv-option]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        qvContent.querySelectorAll('[data-qv-option]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        select(variants.filter(function (v) { return String(v.id) === btn.dataset.qvOption; })[0]);
      });
    });

    if (qvForm) {
      qvForm.addEventListener('submit', async function (e) {
        e.preventDefault();
        if (!qvAdd || qvAdd.disabled) return;

        var original = qvAdd.textContent;
        qvAdd.disabled = true;
        qvAdd.textContent = 'ADDING...';

        var ok = false;
        try {
          if (typeof window.jafAddToCart === 'function') {
            ok = await window.jafAddToCart(new FormData(qvForm), product.title);
          }
        } finally {
          qvAdd.textContent = original;
          qvAdd.disabled = false;
        }

        if (ok) closeQuickView();
      });
    }
  };
})();
